// extracted by mini-css-extract-plugin
module.exports = {"welcome":"welcome_welcome__WGDs1","intro":"welcome_intro__3CwDx","about":"welcome_about__3z_wn","table":"welcome_table__1Zjqa","resume":"welcome_resume__240np"};